<template>
  <div class="purchase-order-status" :data-id="purchaseOrder.id" v-loading="isLoadingStatus">
    <div>
      <badge class="badge-dot">
        <i :class="statusBadgeColor"></i>
      </badge>
      {{ status_text }}
    </div>
  </div>
</template>

<script>
const SITUACAO = {
  [null]: "Não Liberado",
  [-1]:   "Pedido Inserido – SGV",
  [0]:    "Não Liberado Comercial",
  [1]:    "Pedido Liberado",
  [2]:    "Não liberado Financeiro/Não Assinado",
  [3]:    "Pedido Liberado",
  [4]:    "Não liberado Financeiro/Não Assinado",
  [5]:    "Pedido Liberado",
  [6]:    "Pedido Liberado",
  [7]:    "Pedido Liberado",
  [8]:    "Integralmente Faturado/Perdido",
  [9]:    "Integralmente Faturado/Perdido",
  [10]:   "Pedido Liberado",
  [11]:   "Pedido Cancelado",
  [12]:   "Pedido Liberado",
}

export default {
  name: "purchase-order-status",
  props: {
    purchaseOrder: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    status: {},
    isLoadingStatus: false,
  }),
  mounted() {
    this.getStatus();
  },
  methods: {
    async getStatus() {
      this.isLoadingStatus = true;

      try {
        const response = await this.$http.secured.get(`/api/v1/purchase_orders/${this.purchaseOrder.id}/status`);
        this.status = response.data;
      } catch (error) {
        console.warn("[PurchaseOrderStatus][getStatus]", error)
      }

      this.isLoadingStatus = false;
    }
  },
  computed: {
    status_text() {
      if (this.status && this.status.codigo_situacao) return SITUACAO[this.status.codigo_situacao];
      if (this.status && this.status.situacao) return this.status.situacao;

      return "Não consta no ERP";
    },
    statusBadgeColor() {
      if (!(this.status && this.status.codigo_situacao)) return "bg-danger";

      if (this.status.codigo_situacao == -1) return "bg-success";
      if (this.status.codigo_situacao == 0)  return "bg-danger";
      if (this.status.codigo_situacao == 1)  return "bg-success";
      if (this.status.codigo_situacao == 2)  return "bg-yellow";
      if (this.status.codigo_situacao == 3)  return "bg-success";
      if (this.status.codigo_situacao == 4)  return "bg-danger";
      if (this.status.codigo_situacao == 5)  return "bg-success";
      if (this.status.codigo_situacao == 6)  return "bg-success";
      if (this.status.codigo_situacao == 7)  return "bg-success";
      if (this.status.codigo_situacao == 8)  return "bg-info";
      if (this.status.codigo_situacao == 9)  return "bg-info";
      if (this.status.codigo_situacao == 10) return "bg-success";
      if (this.status.codigo_situacao == 11) return "bg-danger";
      if (this.status.codigo_situacao == 12) return "bg-success";

      return "bg-danger";
    },
  }
};
</script>
